import { Fragment } from "react";
import ReactPlayer from "react-player";

import DescriptiveImage from "components/atoms/DescriptiveImage";
import Quote from "components/atoms/Quote";
import Carousel from "components/molecules/Carousel";
import { ReactSVG } from "react-svg";

const sections = [
  {
    id: 0,
    name: "Fundacja",
    side_sections: [
      {
        id: 0,
        name: "Logotypy",
        content: (
          <Fragment>
            <section className="w-full h-full flex flex-col justify-center items-center gap-4">
              <img src="images/logos/full-512.png" alt="" className="w-96" />
              <img
                src="images/logos/ale-naklejka.svg"
                alt=""
                className="w-96"
              />
            </section>
          </Fragment>
        ),
      },
      {
        id: 1,
        name: "Motto",
        content: (
          <Fragment>
            <section className="h-full flex flex-col space-y-2 justify-center items-center">
              <Quote
                quote="Edukacja - jak poezja - jest sposobem patrzenia na świat."
                author="Ryszard Maciej Łukaszewicz"
              />
              <DescriptiveImage
                src="images/about-us/1.jpg"
                styles=""
                description=""
              />
            </section>
          </Fragment>
        ),
      },
      {
        id: 2,
        name: "Cele",
        content: (
          <Fragment>
            <ol className="pl-4 list-decimal">
              <li>
                Niezależne działanie na rzecz zmian w oświacie, sprzyjających
                poczuciu wolności ludzi wobec alternatyw w edukacji - także
                własnej i swoich dzieci.
              </li>
              <li>
                Optymalizowanie szans rozwojowych i edukacyjnych wedle własnych
                aspiracji każdego, wedle samodzielnego wyboru dróg uczenia się.
              </li>
              <li>
                Respektowanie ekologicznego porządku życia w świetle zmian
                cywilizacyjnych.
              </li>
              <li>
                Wprowadzanie niekonwencjonalnych inicjatyw edukacyjnych jako
                ważnego źródła innowacji społecznych, poprzez wyzwolenie
                ludzkiej inwencji i twórczej energii.
              </li>
            </ol>
          </Fragment>
        ),
      },
      {
        id: 3,
        name: "Działania",
        content: (
          <Fragment>
            <p>Fundacja realizuje swoje cele poprzez:</p>
            <ol className="pl-4 list-decimal">
              <li>
                Oferowanie i wspomaganie projektów praktycznych innowacji na
                rzecz alternatyw w edukacji, a w szczególności w przedszkolu i
                szkole podstawowej.
              </li>
              <li>
                Oferowanie i wspomaganie warsztatów aktywności
                niekonwencjonalnej w obszarze oświaty i inicjatyw obywatelskich.
              </li>
              <li>
                Promocję i wspomaganie inicjatyw na rzecz odkrywania dróg
                ekologicznego porządku życia i bycia, ich bogactwa i
                różnorodności w harmonii z przyrodą.
              </li>
              <li>
                Inicjowania i tworzenia wolnych stref innowacji i eksperymentów
                w edukacji/kształceniu – w środowiskach akademickich i
                pozaakademickich; tworzenie małych, lokalnych „gościńców i
                stacyjek”, uwalniania pozytywnych zmian i spontanicznej
                kreatywności poprzez wspólne/zespołowe działania.
              </li>
              <li>
                Wydawanie zeszytów „Drożdże dla edukacji – prowokowanie zmian”,
                publikowanie prac naukowych i popularnonaukowych, organizowanie
                seminariów warsztatowych, otwartych spotkań, prezentowanie
                autorskich materiałów multimedialnych i filmowych.
              </li>
              <li>
                Kształcenie i doskonalenie adeptów i liderów nowych jakości
                edukacji w kolejnych dekadach XXI wieku; kształcenie animatorów
                warsztatów aktywności niekonwencjonalnej.
              </li>
              <li>
                Uczenie autorskiej metody projektowania okazji edukacyjnych oraz
                narracyjnego tworzenia układu i doboru treści edukacyjnych,
                uczenia sztuki rozwijania i pożytkowania wyobraźni dla
                odmieniania świata na lepsze i przekraczania siebie.
              </li>
            </ol>
          </Fragment>
        ),
      },
    ],
  },
  {
    id: 2,
    name: "Misja",
    side_sections: [
      {
        id: 0,
        name: "Drożdże",
        content: (
          <Fragment>
            <section className="flex justify-center">
              <DescriptiveImage
                src="images/about-us/9.jpg"
                styles=""
                description=""
              />
            </section>
          </Fragment>
        ),
      },
      {
        id: 1,
        name: "Zależy nam na Was",
        content: (
          <Fragment>
            <section className="flex justify-center">
              <DescriptiveImage
                src="images/about-us/11.jpg"
                styles=""
                description=""
              />
            </section>
          </Fragment>
        ),
      },
      {
        id: 2,
        name: "Nieznośny",
        content: (
          <Fragment>
            <section className="flex flex-col max-w-max mx-auto">
              <ReactPlayer url={"https://youtu.be/KhV7wYj0lQE"} />
              <span className="text-xl text-center">(12 minut)</span>
            </section>
          </Fragment>
        ),
      },
    ],
  },
  {
    id: 3,
    name: "Skąd przychodzimy",
    side_sections: [
      {
        id: 0,
        name: "Świeradów Zdrój",
        content: (
          <Fragment>
            <section className="flex flex-col justify-center gap-6">
              <a
                href="documents/Jeszcze_jedna_kraina_Gór_Izerskich.pdf"
                className="flex gap-4 justify-between items-center p-4 rounded-3xl bg-slate-200 border border-slate-300 group"
              >
                <span>
                  Publikacja{" "}
                  <span className="font-semibold underline group-hover:no-underline group-hover:opacity-80">
                    "Jeszcze jedna kraina Gór Izerskich"
                  </span>
                </span>
                <ReactSVG
                  src="icons/arrow-top-right-on-square.svg"
                  className="w-6"
                />
              </a>

              <DescriptiveImage
                src="images/about-us/12.jpg"
                styles=""
                description=""
              />
            </section>
          </Fragment>
        ),
      },
      {
        id: 1,
        name: "Historia",
        content: (
          <Fragment>
            <section className="space-y-2">
              <p>
                Czy robiliśmy coś wcześniej? Tak i to przez ponad trzy dekady:{" "}
                <span className="italic">nie jesteśmy znikąd!</span>
              </p>
              <p>
                Korzenie sięgają Uniwersytetu Wrocławskiego, na którym
                zawiązaliśmy projekt pod nazwą Wrocławska Szkoła Przyszłości
                (1972). Wrocławska Szkoła Przyszłości (WSP) była najstarszą taką
                inicjatywą w Polsce; miała status placówki eksperymentalnej
                nadany przez MEN jako szkoła niepubliczna. Prowadziliśmy ją z
                sukcesami przez 25 lat (zob. R. M. Łukaszewicz:{" "}
                <span className="italic">
                  Wrocławska Szkoła Przyszłości: dla duchowości – dla wyobraźni
                  – dla praktyki
                </span>
                , Wrocław, 2010 r.; R. M. Łukaszewicz:{" "}
                <span className="italic">
                  Wrocławska Szkoła Przyszłości Plus czyli lepsze jest możliwe:
                  działania praktyczne, wizje i projekcje nowego – innego –
                  twórczego
                </span>
                , Wrocław, 2020 r.).
              </p>
              <p>
                W latach 1990-2004 organizowaliśmy Salony Edukacji Ekologicznej
                pod nazwą NATURAmy (natura & my) w Świeradowie-Zdroju.
                Przesłaniem tych warsztatów było budowanie kontrapunktu między
                zagrożeniami naszej cywilizacji, a humanistycznymi niepokojami,
                które odnajdujemy w wielkich obrazach – metaforach „świata na
                opak” mistrzów P. Bruegla i H. Boscha (zob. R. M. Łukaszewicz:{" "}
                <span className="italic">
                  „Leczenie głupoty” i... czyli Salony Edukacji Ekologicznej
                </span>
                NATURAmy, Wrocław, 1996 r.).
              </p>
              <p>
                W roku 1993 uczestniczyliśmy w międzynarodowym projekcie
                edukacyjnym: <span className="italic">NAUCZYCIELE ŚWIATA</span>,
                w sekwencji filmów dokumentalnych. Projekt był realizowany z
                inicjatywy Japończyków (Japonia, USA, Australia, Kanada, Korea
                Płd., Finlandia, Polska). Zaprezentowaliśmy odcinek filmowy pod
                tytułem:{" "}
                <span className="italic">Czy człowiek ma trzecią rękę?</span>{" "}
                (ponad 50 min.; scenariusz i realizacja zajęć z dziećmi – R. M.
                Łukaszewicz). Ponadto, jesteśmy autorami ponad 30 realizacji
                filmowych i prezentacji multimedialnych.
              </p>
              <p>
                W latach 1993-2017 prowadziliśmy Międzynarodowy Ośrodek Działań
                Niekonwencjonalnych dla/w Edukacji. Stacja Edukacji Ekologicznej
                (Czerniawa-Zdrój), w ramach którego, w roku 2001,
                zorganizowaliśmy Europejskie Forum Ekologiczne Dzieci
                EURONATURAmy, dla ponad 200 uczestników; organizacja i
                prowadzenie dr K. Leksicka i prof. R. M. Łukaszewicz wraz z
                Zespołem (zob. R.M. Łukaszewicz, K. Leksicka:{" "}
                <span className="italic">Głos dzieci</span>, Wrocław, 2002 r.).
              </p>
              <p>
                Ponadto, możemy się poszczycić rozbudowanym dorobkiem badań
                akademickich, kilkudziesięcioletnimi studiami eksperymentalnymi
                oraz wieloletnimi, wielorakimi działaniami praktycznymi w kraju
                i za granicą (zob. Ryszard Maciej Łukaszewicz:{" "}
                <span className="italic">
                  Opowieści drogi: Wrocławska Szkoła Przyszłości i Fundacja
                  Wolne Inicjatywy Edukacyjne czyli każdy więcej może, mniej
                  musi. Dobre nie wystarcza, gdy lepsze jest możliwe
                </span>
                , Wrocław, 2021 r.).
              </p>
              <div>
                <p>Z końcem roku 2021 zostało zrobione, co następuje:</p>
                <ol className="pl-4 list-decimal">
                  <li>imienne powołanie Forum Konsultacji Projektów;</li>
                  <li>
                    odbyło się spotkanie w Wydziale Edukacji Urzędu
                    Marszałkowskiego we Wrocławiu;
                  </li>
                  <li>opracowano pierwszą, wstępną wersję projektu oraz</li>
                  <li>
                    opracowano koncepcję architektoniczną „Gościńca edukacji”;
                  </li>
                  <li>
                    częściowo zaktualizowano kontakty lokalne w Euroregionie
                    „Nysa” i konsultowano nowe (m.in. Gryfów, Mirsk, Świeradów,
                    Jelenia Góra, Stara Kamienica).
                  </li>
                </ol>
              </div>
            </section>
          </Fragment>
        ),
      },
    ],
  },
  {
    id: 4,
    name: "Kim jesteśmy",
    side_sections: [
      {
        id: 0,
        name: "Ryszard Maciej Łukaszewicz",
        content: (
          <Fragment>
            <Carousel
              slides={[
                {
                  id: 0,
                  bg_image: "images/about-us/1.jpg",
                },
                { id: 1, bg_image: "images/about-us/2.jpg" },
                { id: 2, bg_image: "images/about-us/3.jpg" },
                { id: 3, bg_image: "images/about-us/4.jpg" },
                { id: 4, bg_image: "images/about-us/5.jpg" },
                { id: 5, bg_image: "images/about-us/6.jpg" },
                { id: 6, bg_image: "images/about-us/7.jpg" },
                { id: 7, bg_image: "images/about-us/8.jpg" },
              ]}
            />
          </Fragment>
        ),
      },
      {
        id: 1,
        name: "Biogram",
        content: (
          <Fragment>
            <section className="space-y-2">
              <p>Założyciel i Dobry Duch Fundacji</p>
              <p>Prof. Ryszard Maciej Łukaszewicz</p>
              <div className="max-w-[80%] mx-auto">
                <Quote quote="Biografię konstruuje się życiem, a nie pisze; konstruuje i rekonstruuje ciągle od nowa, poprzez nowe i inne, ale zawsze własne interpretacje. Pamięta i wierzy, iż człowiek jest „kimś” poprzez to, że staje się sobą. Życie wodzi i zwodzi różnymi drogami, ale tak naprawdę liczy się odkrywanie drogi w sobie!" />
              </div>
              <p>
                Absolwent pedagogiki, historii i resocjalizacji na Uniwersytecie
                Wrocławskim; od 2001 r. profesor zwyczajny.
              </p>
              <p>
                Od lat 70-tych autor i lider projektów związanych z
                praktykowaniem edukacji alternatywnej, m.in.: Wrocławska Szkoła
                Przyszłości (WSP); warsztaty w cyklach rocznych i kilkuletnich
                (Wrocław, Słupsk, Kalisz); Fundacja Wolne Inicjatywy Edukacyjne:
                WIE (od 1990); Salon Edukacji Ekologicznej NATURAmy w
                Świeradowie Zdroju; Międzynarodowy Ośrodek Działań
                Niekonwencjonalnych dla/w Edukacji w Świeradowie Zdroju;
                Fundacja Alternatyw Lepszej Edukacji: Gościniec Czterech
                Żywiołów z siedzibą w Świeradowie-Zdroju (od 2019).
              </p>
              <p>
                Organizator konferencji i seminariów na temat innowacji
                edukacyjnych i studiów porównawczych systemów oświatowych w
                Polsce i na świecie.
              </p>
              <p>
                Członek i aktywny uczestnik wielu organizacji, m.in.: Komitetu
                Prognoz Polska w XXI wieku przy Prezydium PAN (1990-1993,
                1993-1995); Komitetu Nauk Pedagogicznych PAN, (1990-1992,
                1994-1996); Sekcji Nauk Społecznych KBN (1995-1996);
                Europejskiego Forum na rzecz Wolności w Edukacji – Witten,
                Niemcy (od 1989); Międzynarodowego Stowarzyszenia Edukacji
                Ekologicznej – Giessen, Niemcy (od 1994); Rady Programowej
                Stowarzyszenia Na Rzecz Wszystkich Istot – Bielsko Biała (od
                19960; Kapituły Funduszu Stypendialnego dla dzieci uzdolnionych
                Jolanty i Aleksandra Kwaśniewskich (1996-2016); Polskiego
                Towarzystwa Pedagogicznego; Rady Naukowej Polskiego Towarzystwa
                Pedagogicznego (od 2017), Polskiego Stowarzyszenia Kreatywności.
              </p>
              <p>
                Autor ponad 200 rozmaitych publikacji i artykułów, w tym 21
                własnych pozycji książkowych; inspirator i scenarzysta ponad 30
                filmów o edukacji alternatywnej i ekologicznej. Redaktor
                wydawniczych serii czasopism; m.in. biuletynu{" "}
                <span className="italic">NATURAmy</span>,{" "}
                <span className="italic">Szukamy lepszej szkoły</span>,{" "}
                <span className="italic">
                  Gazety Wolnych Inicjatyw Edukacyjnych
                </span>
                .
              </p>
              <p>
                Główne zainteresowania badawcze: innowacje i alternatywy w
                edukacji, eksperymenty szkolne, antropologia filozoficzna i
                kulturowa, problematyka globalna i ekologiczna, cywilizacyjne
                wyzwania i zagrożenia.
              </p>
              <p>
                Prywatnie miłośnik sportu (tenis, narciarstwo, jogging),
                górskiej włóczęgi, dobrej kuchni i niekonwencjonalnych,
                spontanicznych zdarzeń; artystyczna dusza Wodnika o galopującej
                wyobraźni – autor tomików{" "}
                <span className="italic">Zapach maciejki</span> (1992),{" "}
                <span className="italic">Podwórka z maciejką</span> (1997),{" "}
                <span className="italic">Wigilijne maciejki</span> (1999),{" "}
                <span className="italic">Szuflady maciejki</span> (2009),{" "}
                <span className="italic">Opłatki maciejki</span> (2014),{" "}
                <span className="italic">Zauroczenia maciejki</span> (2021).
                Przeciwnik filozofii kropki nad „i”.
              </p>
            </section>
          </Fragment>
        ),
      },
      {
        id: 2,
        name: "Siła ludzi",
        content: (
          <Fragment>
            <section className="space-y-2">
              <p>Kim jesteśmy? Ludźmi dobrej woli, aby zmieniać co nas boli.</p>
              <p>
                Jesteśmy pedagogami, ale przede wszystkim – rodzicami.
                Odnaleźliśmy się i połączyli w niezgodzie na jednowymiarowe
                rozumienie edukacji. A edukacja, to przecież{" "}
                <span className="italic">
                  możliwości kreowania możliwości ludzi
                </span>
                . To – używając metafory – sięganie/wydobywanie na jaw diamentów
                z nieskończenie bogatej „kopalni” ludzkiego potencjału. To w
                procesie edukacji – jak diamenty w rękach zmyślnych jubilerów –
                ów potencjał zyskuje radykalnie na wartości. A to, ile zyskuje
                zależy właśnie od tego, z jaką edukacją mamy/możemy mieć do
                czynienia.
              </p>
              <p>
                Dobra wola, mocna wola, to kategorie, które z trudem znajdziemy
                nawet w starych podręcznikach psychologii; można żartobliwie
                powiedzieć, że właśnie my – ludzie, łańcuchy dobrej woli –
                „maratończycy” dobiegamy z tarczą; dobra i długo trwająca wola
                bierze się z tego, co nas boli, co boli ludzi i społeczeństwo
                obywatelskie.
              </p>
              <p>
                Wspierają nas kompetentni i doświadczeni przedstawiciele
                środowisk akademickich, o znaczącym dorobku poczynań
                praktycznych w zakresie twórczych inicjatyw edukacyjnych, m.in.:
                prof. Jolanta Zwiernik, prof. Joanna Maria Garbula, prof. Beata
                Gola.
              </p>
              <p>
                Zawsze, jeśli lepsze jest możliwe, to dobre nie wystarcza; warto
                zmieniać świat na lepsze i przekraczać siebie.
              </p>
            </section>
          </Fragment>
        ),
      },
    ],
  },
  {
    id: 5,
    name: "Dokąd zmierzamy",
    side_sections: [
      {
        id: 0,
        name: "Możliwości",
        content: (
          <Fragment>
            <section className="space-y-2">
              <p>DOKĄD ZMIERZAMY? Do otwierania możliwości dla przyszłości.</p>
              <p>
                Edukacja jest wielką okazją próbowania świata i siebie. Ona
                przecież zawsze gromadzi czujne, wrażliwe, czasami oporne, ale
                zawsze chłonne stworzenia – w pierwszej kolejności dzieci i
                młodych. Właśnie dzięki niej można dokonywać rzeczy niemożliwych
                i być niezadowolonym ze zwykłego, utartego porządku ludzkiej
                egzystencji. Dla nich jest ona nie tylko „ziemią obiecaną” czy
                żeglowaniem ku „trafnym utopiom”, lecz także wielkim kęsem
                życia. Spontanicznie i z niecierpliwością, z uwagą i
                wytrwałością, pragną używać rąk i rozumu, aby doświadczać,
                bezpośrednio dotykać, a nie jedynie ogarniać myślą, zamienioną
                na czynności pozorne. Chcą ciągle od nowa stawiać znak równości
                między twórczością a zmianą, a nie odtwarzać dany ład.
                Potrzebują doświadczać siebie jako części świata, aby intuicją,
                fantazją, kreacją i zabawą, ekspresją i emocjami sprzyjać
                ekologicznemu porządkowi życia. Dlatego w obrazach przyrody
                szukają metafor dla nowych, alternatywnych inspiracji oraz
                sensów, które mają wyrazić ich oczekiwania.
              </p>
            </section>
          </Fragment>
        ),
      },
      {
        id: 1,
        name: "Zielony manifest",
        content: (
          <Fragment>
            <section className="flex justify-center">
              <DescriptiveImage
                src="images/about-us/13.jpg"
                styles=""
                description=""
              />
            </section>
          </Fragment>
        ),
      },
      {
        id: 2,
        name: "Poetyka marzeń",
        content: (
          <Fragment>
            {" "}
            <section className="space-y-2">
              <p>
                To właśnie marzenia są tymi niezwykłymi myślami obdarzonymi mocą
                sprawczą.
              </p>
              <p>
                Gaston Bachelard w Poetyce marzeń pisze przejmująco i pięknie:
              </p>
              <div className="max-w-[80%] mx-auto">
                <Quote
                  quote="Kiedy marzyciel marzenia oddalił już od siebie wszystkie
                „zainteresowania”, które zagracały codzienne życie, kiedy
                odizolował się od troski, jaką jest dla niego troska innych,
                kiedy naprawdę stał się autorem swojej samotności, kiedy
                wreszcie może marzyć o jakiejś pięknej stronie Wszechświata, nie
                licząc godzin, marzyciel odczuwa wówczas pewien byt, który się w
                nim otwiera. Nagle marzyciel taki jest marzycielem świata.
                Otwiera się na świat i świat się przed nim otwiera. Nigdy nie
                widziało się świata należycie, jeśli to, co się widziało, nie
                było przedmiotem marzenia."
                />
              </div>

              <p>Stawiamy na myśli obdarzone mocą!</p>
            </section>
          </Fragment>
        ),
      },
    ],
  },
];

export default sections;
